import type { SVGProps } from "react";

export function CorporateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 16.5V4.5C9 3.08579 9 2.37868 8.56065 1.93934C8.1213 1.5 7.41421 1.5 6 1.5H4.5C3.08579 1.5 2.37868 1.5 1.93934 1.93934C1.5 2.37868 1.5 3.08579 1.5 4.5V13.5C1.5 14.9142 1.5 15.6213 1.93934 16.0606C2.37868 16.5 3.08579 16.5 4.5 16.5H9Z"
        stroke="currentColor"
        strokeWidth="1.125"
      />
      <path
        d="M9 16.5H13.5C14.9142 16.5 15.6213 16.5 16.0606 16.0606C16.5 15.6213 16.5 14.9142 16.5 13.5V9C16.5 7.5858 16.5 6.87868 16.0606 6.43934C15.6213 6 14.9142 6 13.5 6H9"
        stroke="currentColor"
        strokeWidth="1.125"
      />
      <path
        d="M13.875 12H11.625M13.875 9H11.625"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M6.375 10.5H4.125M6.375 7.5H4.125M6.375 4.5H4.125"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </svg>
  );
}
